module.exports = __webpack_public_path__ + "img/baipei7.c718826d.jpg";